import './PageCard.scss'

import {
	Card,
	CardContent,
	CardImage,
	CardImageLabel,
	CardImageOverlay,
	CardLink,
	CardText,
	CardTitle,
	CardType
} from '../../ui/Card'

import {Icon} from '../../../views/ui/Icon'
import React from 'react'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('pagecard', ['row'])

export type PageCardType = CardType & {
	icon?: 'company' | 'register' | 'volunteer'
	imageLabel?: string
}

export const PageCard: React.FC<PageCardType> = ({
	url,
	image,
	imageLabel,
	icon,
	title,
	text,
	linklabel
}) => {
	return (
		<Card className={styles()}>
			<CardImage image={image} url={url} title={title}>
				<CardImageOverlay />
				{imageLabel && <CardImageLabel>{imageLabel}</CardImageLabel>}
			</CardImage>
			<CardContent>
				{icon ? (
					<PageCardRow icon={icon} url={url} title={title} text={text} />
				) : (
					<PageCardContent
						url={url}
						title={title}
						text={text}
						linklabel={linklabel}
					/>
				)}
			</CardContent>
		</Card>
	)
}

const PageCardContent: React.FC<PageCardType> = ({
	url,
	title,
	text,
	linklabel
}) => {
	const t = useTranslation('cards').page

	return (
		<>
			<CardTitle title={title} url={url} />
			<CardText text={text} />
			<CardLink url={url} description={linklabel || t.linklabel} />
		</>
	)
}

const PageCardRow = ({icon, url, title, text}) => (
	<div className={styles.row()}>
		<div className={styles.row('left')}>
			<div className={styles.row('left-icon')}>
				<Icon icon={icon} />
			</div>
		</div>
		<div className={styles.row('right')}>
			<PageCardContent url={url} title={title} text={text} />
		</div>
	</div>
)
